import { setActiveItemInputKeys } from '../../../State/activeItemInputKeys';

export default ({ valuationItemId }) => async (dispatch) => {
  
  dispatch(setActiveItemInputKeys({ valuationItemId, input: 'percentage' }))

}